// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64087c0a","455":"01c29670","977":"6b47cae3"}[chunkId] + ".chunk.js";
};